import { render } from "./newEnterprise.vue?vue&type=template&id=37b1e3d6"
import script from "./newEnterprise.vue?vue&type=script&lang=js"
export * from "./newEnterprise.vue?vue&type=script&lang=js"

import "./newEnterprise.vue?vue&type=style&index=0&id=37b1e3d6&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__